import React from 'react';

import { Icon } from '@chakra-ui/react';

export const CreditCardIcon = props => (
  <Icon viewBox="0 0 25 25" color="inherit" h="full" w="full" {...props}>
    {/* Scale the card around its center so it uses the full parent icon area. */}
    <path
      d="M4.5 10.5H20.5M4.5 9.5H20.5M4.5 11.5H20.5M7 15.5H14M5.5 18.5H19.5C20.0523 18.5 20.5 18.0523 20.5 17.5V7.5C20.5 6.94772 20.0523 6.5 19.5 6.5H5.5C4.94772 6.5 4.5 6.94772 4.5 7.5V17.5C4.5 18.0523 4.94772 18.5 5.5 18.5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
      transform="translate(12.5 12.5) scale(1.3) translate(-12.5 -12.5)"
    />
  </Icon>
);
